import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import { getAppSetting } from 'Shared/ApplicationSettings';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { setAcceptLanguage } from 'Shared/xStateManagement/sessionBased';
import { APIDOMAIN, apiEndpoint, mergeArrays } from '@ibinder/common-utils';

const getLocaleFromiBinderi18nCookie = () => {
  const IBINDERI8N_COOKIE_REGEXP =
    /(?:(?:^|.*;\s*)ibinderi18n\s*\=\s*(?<iBinderi18nCookieValue>[^;]*).*$)|^.*$/;
  const DEFAULTLANGUAGE = 'en';
  const ExtractFromCookie = IBINDERI8N_COOKIE_REGEXP.exec(document.cookie);

  if (ExtractFromCookie === null) {
    return DEFAULTLANGUAGE;
  }

  const {
    groups: { iBinderi18nCookieValue }
  } = ExtractFromCookie;

  return !!iBinderi18nCookieValue
    ? JSON.parse(decodeURIComponent(iBinderi18nCookieValue)).language
    : DEFAULTLANGUAGE;
};
//TODO: We will have to give possibility to load more than one namespace into one application
// for sharing common translations.
const SHARED_NAMESPACES = ['error', 'common'];
const GENERIC_TRANSLATION_NAMESPACE = 'translations';

export default (
  i18n,
  defaultNS,
  useSuspense = true,
  optionalNamespaces: string[] = SHARED_NAMESPACES
) => {
  const localizationEndpoint = apiEndpoint(
    getAppSetting('REACT_APP_LOCALIZATION_API_URL')
  )(APIDOMAIN.localization, 'v2/admin-ui');

  i18n
    .use(ChainedBackend)
    .use(intervalPlural)
    .use(initReactI18next)
    .init(
      {
        lng: getLocaleFromiBinderi18nCookie(),
        // This is necessary to actually have control over the fallback chain
        load: 'currentOnly',
        fallbackLng: 'en',
        ns: GENERIC_TRANSLATION_NAMESPACE,
        defaultNS: [],
        interpolation: {
          escapeValue: false // not needed for react!!
        },
        react: {
          defaultTransParent: 'div', // needed for preact - Vet ej?
          useSuspense
        },
        backend: {
          backends: [LocalStorageBackend, Backend],
          backendOptions: [
            {
              expirationTime:
                parseInt(
                  getAppSetting(
                    'REACT_APP_LOCALIZATION_LOCALSTORAGE_CACHE_EXPIRATION_IN_SECONDS'
                  )
                ) * 1000 // the value set should be in ms.
            },
            {
              loadPath: `${localizationEndpoint.toString()}/{{lng}}/${GENERIC_TRANSLATION_NAMESPACE}.json`
            }
          ]
        }
      },
      () => {
        setAcceptLanguage(i18n.language);
      }
    );
};

export const withSharedNS = (
  useFn: (ns?: string | string[], options?: any) => any,
  ns: string | string[],
  sharededNamespace: string | string[] = SHARED_NAMESPACES
) => {
  return useFn(
    mergeArrays(typeof ns === 'string' ? [ns] : ns, SHARED_NAMESPACES)
  );
};
